module.exports = __webpack_public_path__ + "img/SETTING.e29dc971.svg";